import { ScoreTopic } from '@/types'
import { queryClient } from '../queryClient'
import { AggregatedScoreCategories } from './categories'

export const organisationQueryKeys = {
  unknownOrganisation: ['unknown-organisation'],
  categories: ['categories'],
  topicCategories: queryClient.dynamicQueryKey<AggregatedScoreCategories>((topic: string) => [
    'topicCategories',
    topic,
  ]),
  scoreTopics: queryClient.queryKey<ScoreTopic[]>(['scoreTopics']),
}
